"use strict";
/// <reference path="../../lsb/framework/2.components/0_icommand.ts" />
/// <reference path="../../lsb/framework/2.components/2_icomponent.ts" />
/// <reference path="../../lsb/framework/3.dispatcher/dispatcher.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
//TODO: LSBV4: revert this file to version #41495
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var l = require("lenovo");
var localstorageHelper = require("../src/LocalStorage");
var lsbInstall = require("../../lsb/ui-components/lsbsetup/src/lsbsetup");
var lsbInstallStatus = require("../../lsb/ui-components/lsbsetup/src/lsbupdate");
var common_1 = require("../../psp_driverlist/src/common");
var localstorage = new localstorageHelper.LocalStorage();
var MyDownloadList = [];
var DownloadLateType;
(function (DownloadLateType) {
    DownloadLateType[DownloadLateType["Single"] = 0] = "Single";
    DownloadLateType[DownloadLateType["Multiple"] = 1] = "Multiple";
})(DownloadLateType = exports.DownloadLateType || (exports.DownloadLateType = {}));
exports.GetLocalStorageList = function () {
    var existList = new Array();
    var downLoadObj = localstorage.Get("DLM");
    if (downLoadObj && downLoadObj != "undefined") {
        var lst = JSON.parse(downLoadObj);
        if (lst) {
            existList = lst;
        }
    }
    return existList;
};
var DS_FileTypes;
(function (DS_FileTypes) {
    DS_FileTypes[DS_FileTypes["EXE"] = 0] = "EXE";
    DS_FileTypes[DS_FileTypes["README"] = 1] = "README";
})(DS_FileTypes = exports.DS_FileTypes || (exports.DS_FileTypes = {}));
var DS_FileFrom;
(function (DS_FileFrom) {
    DS_FileFrom[DS_FileFrom["DOWNLOADSLIST"] = 0] = "DOWNLOADSLIST";
    DS_FileFrom[DS_FileFrom["DOWNLOADSDETAILE"] = 1] = "DOWNLOADSDETAILE";
})(DS_FileFrom = exports.DS_FileFrom || (exports.DS_FileFrom = {}));
var DownloadLater = /** @class */ (function (_super) {
    __extends(DownloadLater, _super);
    function DownloadLater(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            var dType = _this.props["data-type"];
            var ds = _this.props["data-ds"];
            var f = _this.props["data-file"];
            var diver = _this.props["data-driver"];
            if (dType == DownloadLateType.Single) {
                _this.ToggleIntoShoppingCart(ds, f, diver);
            }
            else { //DownloadLateType.Multiple
                var isAllSelected = _this.IsAllSelectOnCurrenrDS();
                f.forEach(function (value, index) {
                    var fUrl = value.URL;
                    var dIndex = -1;
                    if (fUrl)
                        dIndex = fUrl.indexOf("download.lenovo.com");
                    if (dIndex == 8 || dIndex == 7)
                        _this.ToggleIntoShoppingCart(ds, value, diver, isAllSelected);
                });
            }
            _this.forceUpdate();
            if (_this.props["call-back"]) {
                _this.props["call-back"]();
            }
            MyDownloadList = exports.GetLocalStorageList();
            DLMReRender();
        };
        return _this;
    }
    DownloadLater.prototype.IsExist = function () {
        var ds = this.props["data-ds"];
        var f = this.props["data-file"];
        return IsInShoppingCart(ds, f.URL);
    };
    DownloadLater.prototype.IsAllSelectOnCurrenrDS = function () {
        var driver = this.props["data-driver"];
        var ExistList = exports.GetLocalStorageList();
        if (ExistList && driver.Files != null) {
            var files = driver.Files.filter(function (item) {
                var fUrl = item.URL;
                var dIndex = -1;
                if (fUrl)
                    dIndex = fUrl.indexOf("download.lenovo.com");
                return dIndex == 7 || dIndex == 8;
            });
            var ds_files = ExistList.filter(function (item) { return item.Product == driver.DocId && item.FileType != DS_FileTypes.README; });
            if (ds_files)
                return ds_files.length == files.length ? true : false;
        }
        return false;
    };
    DownloadLater.prototype.ToggleIntoShoppingCart = function (ds, file, diver, isAllSelected) {
        var f = file;
        var dType = this.props["data-type"];
        var ExistList = exports.GetLocalStorageList();
        var isIn = IsInShoppingCart(ds, f.URL);
        if ((isIn && dType == DownloadLateType.Single) || (isAllSelected && isAllSelected == true && dType == DownloadLateType.Multiple)) { // do remove
            ExistList.splice($.inArray(ExistList.filter(function (item) { return item.FileUrl == f.URL && item.Product == ds; })[0], ExistList), 1);
        }
        else { // do add
            if (isIn == false) {
                var objAdded = new localstorageHelper.DownLoadObjFull();
                objAdded.FileUrl = f.URL;
                objAdded.FileName = f.Name;
                objAdded.FileSize = f.Size;
                objAdded.Version = f.Version;
                objAdded.ReleaseDate = common_1.Utils.driverListDateTime(diver.Date.Unix);
                objAdded.Product = diver.DocId;
                objAdded.DSName = diver.Title;
                objAdded.Selected = true;
                if (f.TypeEnString == "TXT README" && this.props["data-from"] == DS_FileFrom.DOWNLOADSDETAILE) {
                    objAdded.FileType = DS_FileTypes.README;
                }
                if (ExistList && ExistList != null) {
                    ExistList.push(objAdded);
                    if (this.props["track-callback"]) {
                        this.props["track-callback"]();
                    }
                }
            }
        }
        localstorage.Set("DLM", JSON.stringify(ExistList));
    };
    DownloadLater.prototype.render = function () {
        var iconType = "";
        if (this.props["data-type"] == DownloadLateType.Multiple)
            iconType = this.IsAllSelectOnCurrenrDS() ? 'icon-lenovo-drivers-multiple-checked-icon ' : 'icon-lenovo-drivers-multiple-check-icon';
        else
            iconType = this.IsExist() ? 'icon-lenovo-drivers-single-checked-icon ' : 'icon-lenovo-drivers-single-check-icon';
        return (React.createElement("a", { onClick: this.onClick },
            " ",
            React.createElement("span", { "data-isE": this.IsExist(), className: iconType + " icon dow-toggle-into-cart" })));
    };
    return DownloadLater;
}(React.Component));
exports.DownloadLater = DownloadLater;
var dataReRenderFunArr = [];
exports.DLMRender = function (ele, reRenderFun) {
    lsbInstallStatus.LsbUpdateRender();
    ReactDOM.render(React.createElement(DLM, null), ele);
    if (reRenderFun) {
        dataReRenderFunArr.push(reRenderFun);
    }
};
var ExecReRenderEvent = function () {
    dataReRenderFunArr.forEach(function (fun) {
        if (fun) {
            fun();
        }
    });
};
var DLMStateModel = /** @class */ (function () {
    function DLMStateModel() {
        //TotalSize = "0";
        //DriverCount = 0;
        this.ExceptionType = ExceptionEnum.None;
        this.IsShowRst = false;
        this.IsWaiting = true;
        this.IsShowLoading = false;
        this.IsPaused = false;
        this.IsDownloading = false;
        this.DownloadProgressInfo = null;
        this.IsShowDownloadProgress = false;
        this.DownloadingTask = null;
        this.ZipData = null;
        this.Visible = false;
    }
    return DLMStateModel;
}());
var DLM = /** @class */ (function (_super) {
    __extends(DLM, _super);
    function DLM(props) {
        var _this = _super.call(this, props) || this;
        _this.driverCount = 0;
        _this.GetDownloadProgressInfo = function () {
            var itemDownloadings = this.state.DownloadingTask.filter(function (item) {
                return item.status == DownloadStatusEnum.Downloading;
            });
            if (itemDownloadings && itemDownloadings.length > 0) {
                //IsShowDownloadProgress = true;
                var itemDownloading = itemDownloadings[0];
                var idx = $.inArray(itemDownloading, this.state.DownloadingTask);
                return exports.GetDownloadProgressInfo(itemDownloading, idx, this.state.DownloadingTask.length);
            }
        };
        _this.MapClassByStatus = function (status) {
            switch (status) {
                case DownloadStatusEnum.Completed:
                    return "icon-success dlm-success";
                case DownloadStatusEnum.Error:
                    return "icon-close dlm-faild";
                case DownloadStatusEnum.Downloading:
                    return "icon-download dlm-downloading";
                case DownloadStatusEnum.Pausing, DownloadStatusEnum.Paused:
                    return "icon-download dlm-paused";
                case DownloadStatusEnum.Canceling, DownloadStatusEnum.Canceled:
                    return "";
                case DownloadStatusEnum.Waiting:
                    return "icon-dial dlm-waiting";
                case DownloadStatusEnum.Initialized:
                    return "icon-dial dlm-waiting";
                default:
                    return "icon-dial dlm-waiting";
            }
        };
        _this.DLMTrackAction = function (type, name, action) {
            setTimeout(function () {
                l.DTM.push({
                    type: type,
                    name: name,
                    action: action
                });
            }, 100);
        };
        _this.DLMTrackErrorAction = function (type, name) {
            setTimeout(function () {
                l.DTM.Lmd.pusherrorinfTrack(type, name);
            }, 100);
        };
        _this.GetDownloadList = function () {
            var CheckedDrivers = MyDownloadList.filter(function (item) { return item.Selected; });
            if (CheckedDrivers.length > 0) {
                this.state.IsShowLoading = true;
                this.setState(this.state);
                return JSON.stringify(CheckedDrivers.map(function (item) {
                    return { FileId: item.FileUrl, Name: item.FileName, DSName: item.DSName, Url: item.FileUrl };
                }));
            }
            return JSON.stringify([]);
        };
        _this.DLMDownload = function (e) {
            _this.state.DownloadProgressInfo = null;
            var mode = e.target.dataset["mode"];
            var CheckedDrivers = MyDownloadList.filter(function (item) { return item.Selected; });
            if (CheckedDrivers.length > 0) {
                _this.state.IsShowLoading = true;
                _this.state.ExceptionType = ExceptionEnum.None;
                _this.setState(_this.state);
                var data = _this.GetDownloadList();
                var param = { list: data, mode: mode };
                _this.dispatcher.LastCommandType = LSBV4.Component.CommandTypeEnum.ScanStatus;
                _this.dispatcher.LastCommandData = param;
                //this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.LSBInstall, LSBV4.Component.CommandTypeEnum.CheckStatus);
                _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.ScanStatus, param);
                switch (mode) {
                    case "zips":
                        _this.DLMTrackAction("eSupportProcess_Complete", "DLM:DownloadZips", "Button Click");
                        break;
                    case "zip":
                        _this.DLMTrackAction("eSupportProcess_Complete", "DLM:DownloadZip", "Button Click");
                        break;
                    default:
                        _this.DLMTrackAction("eSupportProcess_Complete", "DLM:Download", "Button Click");
                        break;
                }
                var sl_list = JSON.parse(data);
                var sl_array = [];
                for (var _i = 0, sl_list_1 = sl_list; _i < sl_list_1.length; _i++) {
                    var item = sl_list_1[_i];
                    var url = item.Url;
                    var name = url ? url.split('/').pop() : '';
                    sl_array.push(name);
                }
                lmd.downloadList = "< DLM-" + sl_array.length + "- " + sl_array.join(' | ') + ">";
                //console.log(lmd.downloadList);
                common_1.Utils.satelliteTrack('downloadList');
            }
        };
        _this.DLMCancel = function () {
            this.state.IsStopGetStatus = true;
            this.state.IsShowLoading = true;
            this.setState();
            var param = { list: this.GetDownloadList() };
            this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.ScanCancel, param);
            //Track("DLMCancel", 'DLMCancel');
            // $scope.DLMTrackAction("eSupportProcess_Complete", "DLM-Cancel", "Automated");
        };
        _this.DLMPause = function () {
            this.state.IsStopGetStatus = true;
            this.state.IsShowLoading = true;
            this.setState();
            var param = { list: this.GetDownloadList() };
            this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.ScanPause, param);
            this.DLMTrackAction("eSupportProcess_Complete", "DLM:Pause", "Buttion Click");
        };
        _this.DLMResume = function () {
            this.state.IsShowLoading = true;
            this.setState();
            var param = { list: this.GetDownloadList() };
            this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.ScanResume, param);
            // Track("DLMResume", "DLMResume");
            // $scope.DLMTrackAction("eSupportProcess_Complete", "DLM-Resume", "Automated");
        };
        _this.LSBEventInit = function () {
            /*************LSBV4 Event******************/
            ///LSB install events
            _this.dispatcher.BatchAddEventListener(function (data) {
                LSBV4.Utility.Log('LSB install or update success');
                lsbInstall.LsbSetupClose();
                lsbInstallStatus.LsbUpdateClose();
                _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, _this.dispatcher.LastCommandType, _this.dispatcher.LastCommandData);
            }, LSBV4.Utility.EventTypeEnum.PingSuccess, LSBV4.Utility.EventTypeEnum.LSBUpdateSuccess);
            //end of LSB install events
            /*CheckIsDownloadingWhenPageLoad*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMCheckStatusSuccess, function (data) {
                this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.Scan);
                this.DLMTrackAction("eSupportProcess_Complete", "DLM:CheckIsDownloadingWhenPageLoad", "System Generated");
            }.bind(_this));
            /*User Cancel*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.UserCancelled, function (data) {
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM User Cancel', 'UserCancelled');
                //this.DLMTrackAction("eSupportProcess_Complete", "DLM:UserCancelled", "Button Click");
            }.bind(_this));
            /*Download*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.NotLenovo, function (data) {
                this.state.ExceptionType = ExceptionEnum.NotLenovo;
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'NotLenovo');
                //this.DLMTrackAction("Error_Message", "DLM:NotLenovo", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.SystemNotSupport, function (data) {
                this.state.ExceptionType = ExceptionEnum.SystemNotSupport;
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'SystemNotSupport');
                //this.DLMTrackAction("Error_Message", "DLM:SystemNotSupport", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.WrongRequest, function (data) {
                this.state.ExceptionType = ExceptionEnum.WrongRequest;
                this.state.IsShowLoading = false;
                this.state.IsDownloading = false;
                this.state.IsPaused = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'WrongRequest');
                //this.DLMTrackAction("Error_Message", "DLM:WrongRequest", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.Waiting, function (data) {
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.UnhandledException, function (data) {
                this.state.ExceptionType = ExceptionEnum.UnhandledException;
                this.state.IsShowLoading = false;
                this.state.IsShowRst = false;
                this.state.IsPaused = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'UnhandledException');
                //this.DLMTrackAction("Error_Message", "DLM:UnhandledException", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMFailed, function (data) {
                this.state.IsShowLoading = false;
                this.state.ExceptionType = ExceptionEnum.DLMFailed;
                this.state.DownloadingTask = data.Data;
                this.state.IsDownloading = false;
                this.state.IsPaused = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'Failed');
                //this.DLMTrackAction("Error_Message", "DLM:Failed", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMStatusSuccess, function (data) {
                if (this.state.IsStopGetStatus) {
                    return;
                }
                if (data.Data == null || data.Data.length == 0) {
                    return;
                }
                this.state.IsShowLoading = false;
                this.state.IsShowRst = true;
                this.state.IsPaused = false;
                this.state.ExceptionType = ExceptionEnum.None;
                this.state.IsDownloading = true;
                this.state.DownloadingTask = data.Data;
                this.state.ZipData = data.ZipData;
                var itemDownloadings = this.state.DownloadingTask.filter(function (item) {
                    return item.status == DownloadStatusEnum.Downloading;
                });
                if (itemDownloadings && itemDownloadings.length > 0) {
                    this.state.IsShowDownloadProgress = true;
                    var itemDownloading = itemDownloadings[0];
                    var idx = $.inArray(itemDownloading, this.state.DownloadingTask);
                    this.state.DownloadProgressInfo = this.GetDownloadProgressInfo();
                }
                this.setState(this.state);
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMSuccess, function (data) {
                this.state.IsPaused = false;
                this.state.IsShowLoading = false;
                this.state.IsDownloading = false;
                this.state.DownloadingTask = data.Data;
                this.state.ZipData = data.ZipData;
                //some time 'download completed' wont't display
                if (this.state.IsShowRst != true)
                    this.state.IsShowRst = true;
                this.setState(this.state);
                this.DLMTrackAction("eSupportProcess_Complete", "DLM:Success", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMError, function (data) {
                this.state.IsShowLoading = false;
                this.state.ExceptionType = ExceptionEnum.DLMFailed;
                this.state.IsDownloading = false;
                this.state.DownloadingTask = data.Data;
                this.state.IsPaused = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'DownloadError');
                //this.DLMTrackAction("Error_Message", "DLM:DownloadError", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.UserCancelSelectingLocation, function (data) {
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'UserCancelSelectingLocation');
                //this.DLMTrackAction("eSupportProcess_Complete", "DLM:UserCancelSelectingLocation", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.NotEnoughDiskSpace, function (data) {
                this.state.IsShowLoading = false;
                this.state.ExceptionType = ExceptionEnum.NotEnoughDiskSpace;
                this.state.IsDownloading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'NotEnoughDiskSpace');
                //this.DLMTrackAction("Error_Message", "DLM:NotEnoughDiskSpace", "System Generated");
            }.bind(_this));
            /*Cancel*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMCancelSuccess, function (data) {
                this.state.IsStopGetStatus = false;
                this.state.IsShowLoading = false;
                this.state.IsDownloading = false;
                this.state.IsShowRst = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM User Cancel', 'CancelSuccess');
                //this.DLMTrackAction("eSupportProcess_Complete", "DLM:CancelSuccess", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMCancelFailed, function (data) {
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM User Cancel', 'CancelFailed');
                //this.DLMTrackAction("Error_Message", "DLM:CancelFailed", "System Generated");
            }.bind(_this));
            /*Pause*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMPauseSuccess, function (data) {
                this.state.IsStopGetStatus = false;
                this.state.IsShowRst = true;
                this.state.IsDownloading = false;
                this.state.IsPaused = true;
                this.state.DownloadingTask = data.Data;
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackAction("eSupportProcess_Complete", "DLM:PauseSuccess", "System Generated");
            }.bind(_this));
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMPauseFailed, function (data) {
                this.state.IsShowLoading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'Download Pause Failed');
                //this.DLMTrackAction("Error_Message", "DLM:PauseFailed", "System Generated");
            }.bind(_this));
            /*Resume*/
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DLMResumeFailed, function (data) {
                this.state.IsShowLoading = false;
                this.state.ExceptionType = ExceptionEnum.DLMFailed;
                this.state.IsDownloading = false;
                this.setState(this.state);
                this.DLMTrackErrorAction('DLM Error', 'Download Resume Failed');
                //this.DLMTrackAction("Error_Message", "DLM:ResumeFailed", "System Generated");
            }.bind(_this));
        };
        if (!_this.dispatcher) {
            _this.dispatcher = LSBV4.Dispatcher.GetDispatcher();
        }
        _this.state = new DLMStateModel();
        MyDownloadList = exports.GetLocalStorageList();
        _this.ExceptionType = ExceptionEnum.None;
        _this.DLMDownload = _this.DLMDownload.bind(_this);
        _this.DLMCancel = _this.DLMCancel.bind(_this);
        _this.DLMPause = _this.DLMPause.bind(_this);
        _this.DLMResume = _this.DLMResume.bind(_this);
        _this.ToggleMyShoppingCart = _this.ToggleMyShoppingCart.bind(_this);
        _this.CloseMyShoppingCart = _this.CloseMyShoppingCart.bind(_this);
        _this.RemoveDrivers = _this.RemoveDrivers.bind(_this);
        _this.LSBEventInit();
        return _this;
    }
    DLM.prototype.CloseMyShoppingCart = function () {
        this.state.Visible = false;
        this.setState(this.state);
    };
    DLM.prototype.SelectAllItem = function (e) {
        var isChecked = e.currentTarget.checked;
        MyDownloadList.map(function (item) { item.Selected = isChecked; });
        DLMReRender();
    };
    DLM.prototype.RemoveDrivers = function (e) {
        var CheckedDrivers = MyDownloadList.filter(function (item) { return item.Selected; });
        if (CheckedDrivers.length > 0) {
            for (var i = 0; i < CheckedDrivers.length; i++) {
                var item = CheckedDrivers[i];
                var url = item.FileUrl;
                var ds = item.Product;
                var idx = $.inArray(MyDownloadList.filter(function (item) { return item.FileUrl == url && item.Product == ds; })[0], MyDownloadList);
                MyDownloadList.splice(idx, 1);
            }
            localstorage.Set("DLM", JSON.stringify(MyDownloadList));
            this.state.ExceptionType = ExceptionEnum.None;
            this.state.DownloadingTask = [];
            this.state.ZipData = null;
            this.state.IsDownloading = false;
            this.setState(this.state);
            if (MyDownloadList.length < 1) {
                this.CloseMyShoppingCart();
            }
            DLMReRender();
            window.setTimeout(ExecReRenderEvent(), 0);
        }
    };
    DLM.prototype.ToggleMyShoppingCart = function (e) {
        if (this.driverCount < 1)
            return;
        if ($("#divMyDL").is(":visible")) {
            this.CloseMyShoppingCart();
            this.state.Visible = false;
        }
        else {
            this.state.Visible = true;
            $("#divMyDL").css("right", "0px");
            this.setState(this.state);
        }
    };
    ;
    DLM.prototype.componentDidMount = function () {
        //this.UpdateDlmRight();
    };
    DLM.prototype.UpdateDlmRight = function () {
        if (!document.getElementById("dml_right_box")) {
            $("#shoppingcartBox").append("<div id='dml_right_box'></div>");
        }
        ReactDOM.render(React.createElement(DLMRightBanner, { DataCount: MyDownloadList.length, HandleClick: this.ToggleMyShoppingCart }), document.getElementById("dml_right_box"));
    };
    DLM.prototype.render = function () {
        var _this = this;
        //this.UpdateDlmRight();
        var TotalSize = GetTotalSize();
        var driverLst = [];
        MyDownloadList.forEach(function (item, idx) {
            driverLst.push(React.createElement(DlmItem, { "data-item": item, "data-item-index": idx }));
        });
        this.driverCount = MyDownloadList.length;
        return (React.createElement("div", { className: "dow-dlm width100" },
            React.createElement("div", { className: "dow-dlm-lsbinstall" }),
            React.createElement("div", { className: "dow-dlm-lsbinstallstatus" }),
            React.createElement("div", { className: (this.state.Visible ? "" : "dow-hidden") + " dow-divBg" }),
            React.createElement("div", null,
                React.createElement("div", { className: (this.state.Visible ? "dow-dcbox-afterclick" : "") + " downloadCartBox width100" + (MyDownloadList.length > 0 ? " has-list" : ""), "ng-if": "IsWin7OrAbove()" },
                    React.createElement("div", { className: this.state.IsShowLoading ? "" : "dow-hidden" },
                        React.createElement("div", { className: "dow-loading dow-overlay" })),
                    React.createElement("div", { id: "divMyDlBtn", onClick: this.ToggleMyShoppingCart, className: (this.state.Visible ? "dow-dlbtn-afterclick" : "") + " myDlBtn width100", title: l.Translator.translate("My Downloads List") },
                        (function () {
                            if (MyDownloadList.length > 0) {
                                return (React.createElement("span", { className: "downloadCart", id: "downloadCartfull" },
                                    _this.state.IsDownloading ?
                                        React.createElement("span", { className: "dow-dlm-downloading", style: { marginLeft: "5px" } },
                                            React.createElement("img", { id: "downloadingImg", src: "/msa/driver/images/pcg/download_animation.gif" })) :
                                        null,
                                    React.createElement("span", { className: "cart-label " + (_this.state.IsDownloading ? "downloading" : "") }, l.Translator.translate("My Downloads List"))));
                            }
                            else {
                                return (React.createElement("span", { className: "downloadCart", id: "downloadCartempty" },
                                    React.createElement("span", { className: "cart-label" }, l.Translator.translate("My Downloads List"))));
                            }
                        })(),
                        React.createElement("span", { className: "cart-count" }, this.driverCount)),
                    React.createElement("div", { id: "divMyDL", className: (this.state.Visible ? "" : "dow-hidden") + " dow-my-dl-box" },
                        React.createElement("div", { className: "myDownloadList" },
                            React.createElement("div", { className: "myDownloadListTlt" },
                                React.createElement("div", { className: "row dow-dlm-title-no-overflow" },
                                    React.createElement("div", { className: "col-md-6" },
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement("input", { type: "checkbox", name: "selectAll", title: "Select all", checked: MyDownloadList.filter(function (item) { return item.Selected; }).length == MyDownloadList.length && MyDownloadList.length > 0, onChange: this.SelectAllItem })),
                                            React.createElement("div", { className: "col-md-11" }, l.Translator.translate("Title")))),
                                    React.createElement("div", { className: "col-md-6 visible-desktop" },
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-4" }, l.Translator.translate("Version")),
                                            React.createElement("div", { className: "col-md-4" }, l.Translator.translate("Released")),
                                            React.createElement("div", { className: "col-md-4" }, l.Translator.translate("File size")))))),
                            React.createElement("div", { className: "divDowLstScroll" }, driverLst),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12" },
                                    l.Translator.translate("Total Size"),
                                    ": \u00A0 ",
                                    TotalSize,
                                    "\u00A0 MB")),
                            (function () {
                                if (!_this.state.IsDownloading && !_this.state.IsPaused) {
                                    return (React.createElement("div", { className: "dow-buttons" },
                                        React.createElement("a", { onClick: _this.CloseMyShoppingCart, className: "btn btn-default" }, l.Translator.translate("Close")),
                                        (function () {
                                            if (MyDownloadList.filter(function (item) { return item.Selected; }).length > 0) {
                                                return React.createElement("div", { style: { marginLeft: "10px" }, className: "btn-group" },
                                                    React.createElement("button", { type: "button", className: "btn btn-primary", "data-mode": "none", onClick: _this.DLMDownload }, l.Translator.translate("Download")),
                                                    React.createElement("button", { type: "button", className: "btn btn-primary dropdown-toggle", "data-toggle": "dropdown" },
                                                        React.createElement("span", { className: "caret" }),
                                                        React.createElement("span", { className: "sr-only" }, "change")),
                                                    React.createElement("ul", { className: "dropdown-menu", role: "menu" },
                                                        React.createElement("li", null,
                                                            React.createElement("a", { className: "btn", "data-mode": "zips", onClick: _this.DLMDownload }, l.Translator.translate("Download as zips"))),
                                                        React.createElement("li", null,
                                                            React.createElement("a", { className: "btn", "data-mode": "zip", onClick: _this.DLMDownload }, l.Translator.translate("Download as one zip")))));
                                            }
                                            else {
                                                return React.createElement("a", { className: 'btn btn-primary disabled' }, l.Translator.translate("Download"));
                                            }
                                        })(),
                                        React.createElement("a", { onClick: _this.RemoveDrivers, className: MyDownloadList.filter(function (item) { return item.Selected; }).length > 0 ? 'btn btn-default' : 'btn btn-default disabled', id: "removeDownLoad" }, l.Translator.translate("Remove"))));
                                }
                            })()),
                        (function () {
                            if (_this.state.ExceptionType != ExceptionEnum.None) {
                                return (React.createElement(ExceptionMsg, { "data-exception": _this.state.ExceptionType }));
                            }
                        })(),
                        (function () {
                            if (_this.state.IsShowRst) {
                                var downloadTasks = _this.state.DownloadingTask;
                                var tasks = [];
                                downloadTasks.forEach(function (t, idx) {
                                    tasks.push(React.createElement("p", { className: 'itemTlt', name: t.fileid },
                                        React.createElement("span", { className: 'DownloadListSpanIcon ' + _this.MapClassByStatus(t.status) }),
                                        t.name,
                                        "\u00A0 \u00A0 \u00A0 \u00A0",
                                        React.createElement("span", { className: 'fileLocalPath' },
                                            " ",
                                            t.localpath,
                                            " ")));
                                });
                                if (_this.state.DownloadingTask == null || _this.state.DownloadingTask.length == 0) {
                                    return React.createElement("div", null);
                                }
                                return (React.createElement("div", null,
                                    React.createElement("div", { className: "downloadProgress" },
                                        React.createElement("h3", null, _this.state.IsDownloading || _this.state.IsPaused ? l.Translator.translate("Download in Progress") : l.Translator.translate("Download Completed"))),
                                    React.createElement("div", { className: "downloadTasks", id: "downloadTasks" },
                                        React.createElement("div", { className: 'downloadTaskItem' }, tasks)),
                                    (function () {
                                        if ((_this.state.IsDownloading && _this.state.IsShowDownloadProgress) || _this.state.IsPaused) {
                                            return (React.createElement(DownloadProgressBar, { "data-downloadProgressInfo": _this.state.DownloadProgressInfo }));
                                        }
                                    })(),
                                    (function () {
                                        if (_this.state.ZipData) {
                                            if (_this.state.ZipData.ZipStatus == 1) {
                                                return React.createElement("span", { style: { color: '#5cb85c' } },
                                                    l.Translator.translate('The progression of the compression'),
                                                    ": ",
                                                    _this.state.ZipData.CurrentIndex,
                                                    "/",
                                                    _this.state.ZipData.TotalCount);
                                            }
                                            else {
                                                return React.createElement("span", { style: { color: '#5cb85c' } },
                                                    l.Translator.translate('The progression of the compression'),
                                                    ": ",
                                                    l.Translator.translate('Done'));
                                            }
                                        }
                                    })(),
                                    (function () {
                                        if (_this.state.IsDownloading || _this.state.IsPaused) {
                                            return (React.createElement("div", { className: "dow-buttons", id: "downLoadingActionDownload" },
                                                React.createElement("a", { onClick: _this.CloseMyShoppingCart, className: "btn btn-default" }, l.Translator.translate("Close")),
                                                _this.state.IsDownloading ? React.createElement("a", { className: "btn btn-default", onClick: _this.DLMCancel }, l.Translator.translate("Cancel")) : "",
                                                _this.state.IsDownloading && !_this.state.IsPaused ? React.createElement("a", { className: "btn btn-primary", onClick: _this.DLMPause }, l.Translator.translate("Pause")) : "",
                                                !_this.state.IsDownloading && _this.state.IsPaused ? React.createElement("a", { className: "btn btn-primary", onClick: _this.DLMResume }, l.Translator.translate("Resume")) : ""));
                                        }
                                    })()));
                            }
                        })())))));
    };
    DLM.CheckIsDownloading = function () {
        if (!this.dispatcher) {
            this.dispatcher = LSBV4.Dispatcher.GetDispatcher();
        }
        this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.DLM, LSBV4.Component.CommandTypeEnum.CheckStatus);
    };
    return DLM;
}(React.Component));
exports.DLM = DLM;
var DlmItem = /** @class */ (function (_super) {
    __extends(DlmItem, _super);
    function DlmItem(props) {
        var _this = _super.call(this, props) || this;
        _this.DLMFormat = {
            Version: function (val) {
                var version = "";
                if (val != null && val != "") {
                    version = val;
                    version = version.length > 13 ? version.substr(0, 13) + " " + version.substr(13) : version;
                    return version;
                }
                return val;
            },
            Product: function (val) {
                if (val)
                    return val.substr(val.lastIndexOf("/") + 1);
                return val;
            }
        };
        _this.componentWillReceiveProps(_this.props);
        _this.SelectAItem = _this.SelectAItem.bind(_this);
        return _this;
    }
    DlmItem.prototype.componentWillReceiveProps = function (props) {
        this.Item = props["data-item"];
        this.ItemIdx = props["data-item-index"];
    };
    DlmItem.prototype.SelectAItem = function () {
        this.Item.Selected = !this.Item.Selected;
        DLMReRender();
    };
    ;
    DlmItem.prototype.render = function () {
        var fileName = this.Item.FileName;
        var pageType = l.Common.getCurrentRealm();
        if (this.Item.FileUrl && pageType == l.RealmType.Dcg) {
            var _urlArray = this.Item.FileUrl.split("/");
            fileName = _urlArray[_urlArray.length - 1];
        }
        return (React.createElement("div", { className: "row myDownloadListItem" },
            React.createElement("div", { className: "col-md-6" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-1" },
                        React.createElement("input", { type: "checkbox", checked: this.Item.Selected, onChange: this.SelectAItem })),
                    React.createElement("div", { className: "col-md-11" },
                        React.createElement("a", { href: this.Item.FileUrl, "data-download-type": this.Item.Category, "data-download-position": this.ItemIdx + 1 }, fileName)))),
            React.createElement("div", { className: "col-md-6" },
                React.createElement("div", { className: "row visible-desktop" },
                    React.createElement("div", { className: "col-md-4" }, this.DLMFormat.Version(this.Item.Version)),
                    React.createElement("div", { className: "col-md-4" }, this.Item.ReleaseDate),
                    React.createElement("div", { className: "col-md-4" }, this.Item.FileSize)))));
    };
    return DlmItem;
}(React.Component));
exports.DlmItem = DlmItem;
var DownloadProgressBar = /** @class */ (function (_super) {
    __extends(DownloadProgressBar, _super);
    function DownloadProgressBar(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(DownloadProgressBar.prototype, "DownloadProgressInfo", {
        get: function () { return this.props["data-downloadProgressInfo"]; },
        enumerable: true,
        configurable: true
    });
    ;
    DownloadProgressBar.prototype.render = function () {
        if (this.DownloadProgressInfo == null) {
            return null;
        }
        return (React.createElement("div", { className: "progressBarBox" },
            React.createElement("p", null,
                React.createElement("strong", null,
                    this.DownloadProgressInfo.CurrentIdx,
                    "/ ",
                    this.DownloadProgressInfo.TotalCount,
                    ": "),
                this.DownloadProgressInfo.CurrentName),
            React.createElement("div", { className: "progress" },
                React.createElement("div", { className: "progress-bar progress-bar-success", role: "progressbar", "aria-valuemin": "0", "aria-valuemax": "100", style: { width: this.DownloadProgressInfo.DownloadProcess + '%' } })),
            React.createElement("p", null,
                this.DownloadProgressInfo.DownloadProcess,
                "%  | ",
                this.DownloadProgressInfo.DownloadedSize,
                "/ ",
                this.DownloadProgressInfo.TotalSize,
                "| ",
                this.DownloadProgressInfo.Speed,
                "| ",
                this.DownloadProgressInfo.RemainTime)));
    };
    return DownloadProgressBar;
}(React.Component));
exports.DownloadProgressBar = DownloadProgressBar;
;
var ExceptionMsg = /** @class */ (function (_super) {
    __extends(ExceptionMsg, _super);
    function ExceptionMsg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExceptionMsg.prototype.TranslatorExceptionMsg = function () {
        var exceptionType = this.props["data-exception"];
        if (exceptionType != ExceptionEnum.None) {
            return l.Translator.translate(exceptionType);
        }
        else {
            return "";
        }
    };
    ExceptionMsg.prototype.render = function () {
        return (React.createElement("div", { className: "row" },
            React.createElement("p", { className: "col-md-12 dow-msg" }, this.TranslatorExceptionMsg())));
    };
    return ExceptionMsg;
}(React.Component));
var GetTotalSize = function () {
    var totalSize = 0.0;
    var CheckedDrivers = MyDownloadList.filter(function (item) { return item.Selected; });
    $.each(CheckedDrivers, function (index, item) {
        if (item.Selected) {
            var fileSize = item.FileSize;
            totalSize += parseFloat(SizeToTargetUnit(fileSize, "MB").toString());
        }
    });
    if (totalSize <= 0.000001) {
        return "0.00";
    }
    if (totalSize < 0.01) {
        return "0.01";
    }
    return totalSize.toFixed(2);
};
var DLMReRender = function () {
    exports.DLMRender(document.getElementById("shoppingcartBox"));
};
var DLMRightBanner = /** @class */ (function (_super) {
    __extends(DLMRightBanner, _super);
    function DLMRightBanner(props) {
        var _this = _super.call(this) || this;
        _this.thisBottom = 320;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    DLMRightBanner.prototype.componentDidMount = function () {
        var _offsetWidth = $(".dow-dlm-right")[0].offsetWidth;
        this.thisBottom = _offsetWidth + 185;
        this.forceUpdate();
    };
    DLMRightBanner.prototype.handleClick = function () {
        var _this = this;
        if (this.props.DataCount == 0)
            return;
        var isAnimate = false;
        $('html, body').animate({ scrollTop: ($('#shoppingcartBox').offset().top - 260) + "px" }, 300, function () {
            if (isAnimate === false) {
                _this.props.HandleClick();
                isAnimate = true;
            }
        });
    };
    DLMRightBanner.prototype.render = function () {
        return React.createElement("a", { className: "dow-dlm-right", onClick: this.handleClick, style: { bottom: this.thisBottom.toString() + "px" } },
            l.Translator.translate("Download List"),
            " ",
            React.createElement("span", null, this.props.DataCount));
    };
    return DLMRightBanner;
}(React.Component));
var IsInShoppingCart = function (ds, fileUrl) {
    var ExistList = exports.GetLocalStorageList();
    if (!ExistList || ExistList == null) {
        return false;
    }
    return ExistList.filter(function (item) { return item.FileUrl == fileUrl && item.Product == ds; }).length > 0;
};
var SizeToTargetUnit = function (size, targetUnit) {
    var basicRate = [{ unit: "BIT", rate: 1 },
        { unit: "B", rate: 8 },
        { unit: "BYTE", rate: 8 },
        { unit: "KB", rate: 1024 * 8 },
        { unit: "MB", rate: Math.pow(1024, 2) * 8 },
        { unit: "GB", rate: Math.pow(1024, 3) * 8 },
        { unit: "TB", rate: Math.pow(1024, 4) * 8 }];
    var targetRate = Math.pow(1024, 2) * 8; //default MB
    var sizeRate = 1024 * 8; //default KB
    var reUnit = /[a-zA-Z]{1,}/;
    var unit = reUnit.exec(size);
    if (unit == null || unit.length == 0) {
        return 0;
    }
    unit = unit[0].toUpperCase();
    var reSize = /^\d+(\.\d+)?/;
    var sourceSize = reSize.exec(size);
    if (sourceSize == null || sourceSize.length == 0) {
        return 0;
    }
    sourceSize = sourceSize[0];
    $.each(basicRate, function (index, item) {
        if (item.unit === unit) {
            sizeRate = item.rate;
        }
        if (item.unit === targetUnit) {
            targetRate = item.rate;
        }
    });
    return sourceSize * (1.0 * sizeRate / targetRate);
};
var ExceptionEnum = {
    None: "",
    NetworkError: "Network Error",
    NotEnoughDiskSpace: "Not enough disk space",
    UnhandledException: "Unhandled Exception",
    WrongRequest: "Wrong Request",
    NotLenovo: "Not Lenovo",
    SysAlert: "SysAlert",
    SystemNotSupport: "System Not Support",
    DLMFailed: "DLM Failed"
};
var DownloadStatusEnum;
(function (DownloadStatusEnum) {
    DownloadStatusEnum[DownloadStatusEnum["Initialized"] = 0] = "Initialized";
    DownloadStatusEnum[DownloadStatusEnum["Waiting"] = 1] = "Waiting";
    DownloadStatusEnum[DownloadStatusEnum["Downloading"] = 2] = "Downloading";
    DownloadStatusEnum[DownloadStatusEnum["Pausing"] = 3] = "Pausing";
    DownloadStatusEnum[DownloadStatusEnum["Paused"] = 4] = "Paused";
    DownloadStatusEnum[DownloadStatusEnum["Canceling"] = 5] = "Canceling";
    DownloadStatusEnum[DownloadStatusEnum["Canceled"] = 6] = "Canceled";
    DownloadStatusEnum[DownloadStatusEnum["Completed"] = 7] = "Completed";
    DownloadStatusEnum[DownloadStatusEnum["Error"] = 8] = "Error";
})(DownloadStatusEnum || (DownloadStatusEnum = {}));
exports.GetDownloadProgressInfo = function (currentItem, currentIndex, totalcount) {
    var percent = PercentageProgress(currentItem.totalfilesize, currentItem.downloadedsize);
    var totalSize = BytesToSize(currentItem.totalfilesize);
    var downloadedsize = BytesToSize(currentItem.downloadedsize);
    var remaining = Remaining(currentItem.downloadspeed, currentItem.totalfilesize, currentItem.downloadedsize);
    var speed = SpeedBytesToSize(currentItem.downloadspeed);
    var time = MillisecondToDate(remaining);
    return {
        "CurrentIdx": parseInt(currentIndex + 1, 10),
        "TotalCount": totalcount,
        "CurrentName": currentItem.name,
        "DownloadProcess": percent,
        "DownloadedSize": downloadedsize,
        "TotalSize": totalSize,
        "Speed": speed,
        "RemainTime": time
    };
};
var Remaining = function (sp, ts, ds) {
    var remaining = (ts - ds) / sp;
    if (ts - ds == 0)
        return "0";
    return remaining.toPrecision(4);
};
var SpeedBytesToSize = function (bytes) {
    if (bytes === 0)
        return '0 B';
    var k = 1024, sizes = ['B', 'Kbps ', 'Mbps', 'Gbps', 'TB', 'PB', 'EB', 'ZB', 'YB'], i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toPrecision(4) + ' ' + sizes[i];
};
var BytesToSize = function (bytes) {
    if (bytes === 0)
        return '0 B';
    var k = 1024, sizes = ['B', 'KB ', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toPrecision(4) + ' ' + sizes[i];
};
var PercentageProgress = function (t, c) {
    var percent = c / t * 100;
    return percent.toPrecision(4);
};
function twoDigit(number) {
    var twodigit = number >= 10 ? number : "0" + number.toString();
    return twodigit;
}
var MillisecondToDate = function (value) {
    if (value > 86400)
        return ">24 :" + "00 :" + "00";
    var hour = parseInt((value / 3600).toString());
    var min = parseInt(((value % 3600) / 60).toString());
    var sec = parseInt((((value % 3600) % 60)).toString());
    return twoDigit(hour) + " :" + twoDigit(min) + " :" + twoDigit(sec);
};
//window.setTimeout(DLM.CheckIsDownloading(), 0);
